module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_c('h1', [_vm._v("Antho"), _c('span', [_vm._v("logie")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursAll'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n              Parcours"), _c('span', {
    staticClass: "dash"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'authors'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n            Auteurs"), _c('span', {
    staticClass: "dash"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'credits'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n            Crédits"), _c('span', {
    staticClass: "dash"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40abb176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/MainNav.vue
// module id = 98
// module chunks = 0